// extracted by mini-css-extract-plugin
module.exports = {"container":"SuspenseLoader_container__SLq6m","spinner":"SuspenseLoader_spinner__QAZZO","spin":"SuspenseLoader_spin__duzK3"};